<template>
  <div :class="['detail', { inApp: $root.$data.isApp }]">
    <common-title titleName="换课详情" :bcColor="'#f9f9f9'" :zIndex="1000"></common-title>
    <div v-for="(item, index) in orderDetail" :key="index">
      <div class="status">
        <p>{{ filterOrderType(item.changeStatus) }}</p>
        <!-- <p> {{
             Number(item.changeAfterType)  === 1
                ? '换课退差'
                : Number(item.changeAfterType) === 2
                ? '换课补差'
                : Number(item.changeAfterType) === 3
                ? '换课不退不补'
                : ''
            }}</p> -->
        <p>换课</p>
      </div>
      <div class="detail_info">
        <div class="old_info">
          <ul>
            <li v-for="(olditem, oldind) in item.fromProductList" :key="oldind">
              <p>{{ olditem.productName }}</p>
              <span>￥{{ olditem.productAmount }}</span>
            </li>
          </ul>
        </div>
        <div class="new_info">
          <ul>
            <li v-for="(newitem, newind) in item.toProductList" :key="newind">
              <p>{{ newitem.productName }}</p>
              <span>￥{{ newitem.productAmount }}</span>
            </li>
          </ul>
        </div>
      </div>
      <!-- 换课补差价-待支付 -->
      <div class="price_info" v-if="Number(item.changeAfterType) === 2 && Number(item.changeStatus) === 3">
        <ul>
          <li>
            <div>应补差价</div>
            <p>￥{{item.fillAmount}}</p>
          </li>
        </ul>
      </div>
      <!-- 换课补差价-已支付 -->
      <div class="price_info" v-if="Number(item.changeAfterType) === 2 && Number(item.changeStatus) === 4">
        <ul>
          <li>
            <div>实补差价</div>
            <p>￥{{item.fillAmount}}</p>
          </li>
        </ul>
      </div>
      <!-- 换课补差已关闭（超时未支付） -->
      <div class="price_info" v-if="Number(item.changeAfterType) === 2 && Number(item.changeStatus) === 5">
        <ul>
          <li>
            <div>应补差价</div>
            <p>￥{{item.fillAmount}}</p>
          </li>
        </ul>
      </div>
      <!--换课退差价  -->
      <div class="price_info" v-if="Number(item.changeAfterType)  === 1">
        <ul>
          <li>
            <div>应退差价</div>
            <p>￥{{item.refundAmount}}</p>
          </li>
        </ul>
      </div>
      <div class="order_info">
        <ul>
          <li>
            <p>售后编号</p>
            <div>{{ item.changeNo }}<span @click="orderNoCopy"></span></div>
          </li>
          <li>
            <p>售后时间</p>
            <div>{{ item.createTime }}</div>
          </li>
          <li v-if="item.payTime">
            <p>付款时间</p>
            <div>{{ item.payTime }}</div>
          </li>
          <li v-if="filterPaymentType(item.paymentType)">
            <p>支付方式</p>
            <div>{{ filterPaymentType(item.paymentType) }}</div>
          </li>
        </ul>
      </div>
      <div class="fixfoot" v-if="Number(item.changeAfterType) === 2 && Number(item.changeStatus) === 3">
        <p>应补差价 <span>¥{{item.fillAmount}}</span></p>
        <div @click="payment(item.changeNo)">立即支付</div>
      </div>
    </div>
  </div>
</template>

<script>
import CommonTitle from '@/components/header/CommonTitle.vue';
import { copyTool } from '@/utils/tools';
import { reqReplaceDetail } from '@/api/personal/returnClass';
import { orderType, paymentType, refundAmountType } from '../returnClassTools';

export default {
  data() {
    return {
      orderNo: this.$route.query.orderNo,
      orderDetail: [],
    };
  },

  components: { CommonTitle },

  computed: {},

  mounted() { },

  created() {
    this.getOrderDetail();
  },
  methods: {
    orderNoCopy() {
      copyTool(this.orderNo)
        .then(() => {
          this.$toast('复制成功');
        })
        .catch(() => {
          this.$toast('复制失败');
        });
    },
    async getOrderDetail() {
      try {
        const res = await reqReplaceDetail(this.$route.query.orderNo);
        if (res.code === 0) {
          this.orderDetail.push(res.data);
          // console.log(typeof (this.orderDetail[0].changeAfterType))
        } else {
          this.$toast(res.msg);
        }
      } catch (error) {
        this.$toast(error.message);
      }
    },
    // 判断订单状态
    filterOrderType(status) {
      return orderType(status);
    },
    // 判断支付方式类型
    filterPaymentType(status) {
      return paymentType(status);
    },
    // 退款方式类型
    filterfundType(status) {
      return refundAmountType(status);
    },
    // 立即支付
    payment(orderNo) {
      if (this.$root.$data.isApp) {
        // type = '1'表示退换课来源
        this.$sendToApp('payCenter', { orderNo, type: '1' }, false);
        return;
      }
      this.$router.push({
        path: '/cashier',
        query: { orderNo, source: 1 },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.detail {
  width: 86%;
  margin: 0 auto 40px;
  padding-top: 100px;
  &.inApp {
    padding-top: 0;
    padding-bottom: 0;
  }
}
.old_info {
  position: relative;
  padding-bottom: 40px;
  padding-left: 30px;
  border-left: 2px dashed #a5a5a5;
  &::before {
    position: absolute;
    top: 0%;
    left: -16px;
    width: 32px;
    height: 39px;
    background: url('../../../../assets/img/personalImg/old.jpg') no-repeat center;
    background-size: 100% 100%;
    content: '';
  }
}
.new_info {
  position: relative;
  padding-left: 30px;
  &::before {
    position: absolute;
    top: -6%;
    left: -16px;
    width: 32px;
    height: 39px;
    background: url('../../../../assets/img/personalImg/new.jpg') no-repeat center;
    background-size: 100% 100%;
    content: '';
  }
}

.fixfoot {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 36px;
  background-color: #fff;
  p {
    color: #787878;
    font-weight: 400;
    font-size: 25px;
    span {
      color: #ff6c02;
    }
  }
  div {
    @include commonBtn(132px, 43px, $theme_color, 34px, 22px, $bgWhite);
  }
}
.detail_info {
  margin-bottom: 20px;
  padding: 30px;
  background-color: #fff;
  border-radius: 14px;
  li {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 40px;
    margin-bottom: 8px;
    p {
      width: 476px;
      overflow: hidden;
      color: #333;
      font-weight: 400;
      font-size: 28px;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    span {
      color: #333;
      font-size: 25px;
    }
  }
}
.order_info li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  p {
    color: #333;
    font-weight: bold;
    font-size: 25px;
  }
  div {
    color: #787878;
    font-size: 25px;
    span {
      display: inline-block;
      width: 48px;
      height: 48px;
      vertical-align: middle;
      background: url('../../../../assets/img/personalImg/copy.png') no-repeat center;
      background-size: 100% 100%;
    }
  }
}
.price_info {
  margin: 20px 0;
  padding: 30px;
  background-color: #fff;
  border-radius: 14px;
  li {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    div {
      color: #333;
      font-weight: bold;
      font-size: 25px;
    }
    p {
      color: #ff6c02;
      font-weight: bold;
      font-size: 25px;
    }
  }
  li:last-child {
    margin-bottom: 0;
  }
}

.order_info li:last-child {
  margin-bottom: 0;
}
.order_info {
  padding: 30px;
  background-color: #fff;
  border-radius: 14px;
  ul {
    li:first-child {
      margin-bottom: 10px;
    }
  }
}

.status {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  padding: 40px 0;
  p:first-child {
    color: #ff6c02;
    font-weight: 500;
    font-size: 43px;
  }
  p:last-child {
    color: #ff6c02;
    font-weight: 500;
    font-size: 25px;
  }
}
</style>
